import parse from 'lib/url/parse'
import { parseUrlFacets } from 'lib/algolia/v2'
import { observerEpicHelper } from 'epics/helpers'
import { Actions as PageActions } from 'actions/page'
import { Actions as NavigationActions } from 'actions/shared/navigation'
import { getNavigationSearchValue } from 'selectors/shared/navigation'
import { getAlgoliaQueryParams } from '../helpers/url'
import { Actions as AppActions, Constants } from '../actions'
import { getSlugifyDictionary } from '../selectors/facets'

export const clientsideTransitionsEpic = observerEpicHelper(
  [Constants.CLIENTSIDE_TRANSITION],
  async ({ action, observer, store }) => {
    const href = action.payload || ''
    // We need to UPDATE Query when USER uses native HISTORY ( Back | Next )
    const currentQuery = getNavigationSearchValue({ ...store.value })
    const { query: updatedQuery } = parse(href).query || {}

    // We have issues where sometimes QUERIES don't match, Ex: '' !== undefined
    // Make sure one query value exist first then compare
    if ((updatedQuery || currentQuery) && updatedQuery !== currentQuery) {
      observer.next(
        NavigationActions.NAVIGATION_UPDATE_SEARCH({
          value: updatedQuery,
        })
      )
    }

    observer.next(PageActions.SET_PATH(href))
    const slugifyDictionary = getSlugifyDictionary({ ...store.value })
    const selectedFacets = parseUrlFacets({
      dictionary: slugifyDictionary,
      href,
    })
    // Pull Query Variables ()
    const algoliaParams = getAlgoliaQueryParams(action.payload || '')
    observer.next(PageActions.SET_PARAMS(algoliaParams))
    observer.next(
      PageActions.SET_DATA({
        selectedFacets,
      })
    )
    observer.next(AppActions.UPDATE_ALGOLIA(algoliaParams))
    observer.complete()
  }
)

export default [clientsideTransitionsEpic]
